// extracted by mini-css-extract-plugin
export default {"input":"Pn5VCFnXCYHwsYoNQ7wb","mentions":"dvGpMkDZpLVeziyNVIVb","mentions--multiLine":"CELpfL4jOlRFN8alXMZS","mentions__input":"PHKJYhO2DDi7c4hkt21M"};